import { Component, OnInit, ViewChild } from '@angular/core';
import { ModelRestService } from '../../model-rest.service';
import { SessionService } from '../../session.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Segment } from '../../model/segment';
import { Response } from '../../model/response';
import { RouteBooking } from '../../model/routebooking';
import { Country } from '../../model/country';
import { TranslateService } from '@ngx-translate/core';
import { NgbCalendar, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { NgForm, FormGroup, ValidationErrors, AbstractControl } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';
import { I18n, CustomDatepickerI18n } from '../../i18ndatepicker';
/** Inicializa variable para poder usar jquery en componente */
declare var $: any;
declare var gtag;
declare function PixelSearch(DepartureDate, ReturnDate, DestinationCity,
  DestinationStateorRegion, DestinationCountry, NumberOfTravelers): any;
/**Componente de la pantalla donde se mete los datos de los usuarios que viajaran en el tren*/
export interface AllValidationErrors {
  control_name: string;
  error_name: string;
  error_value: any;
}

export interface FormGroupControls {
  [key: string]: AbstractControl;
}

export function getFormValidationErrors(controls: FormGroupControls): AllValidationErrors[] {
  let errors: AllValidationErrors[] = [];
  Object.keys(controls).forEach(key => {
    const control = controls[key];
    if (control instanceof FormGroup) {
      errors = errors.concat(getFormValidationErrors(control.controls));
    }
    const controlErrors: ValidationErrors = controls[key].errors;
    if (controlErrors !== null) {
      Object.keys(controlErrors).forEach(keyError => {
        errors.push({
          control_name: key,
          error_name: keyError,
          error_value: controlErrors[keyError]
        });
      });
    }
  });
  return errors;
}
@Component({
  selector: 'app-step4',
  templateUrl: './step4.component.html',
  styleUrls: ['./step4.component.css'],
  providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }]
})
export class Step4Component implements OnInit {
  @ViewChild('f') form: NgForm;
  private readonly TODAY: NgbDate = this.ngbCalendar.getToday();

  constructor(private location: Location,
    private translate: TranslateService,
    private model: ModelRestService,
    public session: SessionService,
    private router: Router,
    private ngbCalendar: NgbCalendar) { }
  /** .*/
  public paises: Country[] = [];
  /** .*/
  public contactName;
  public contactLast;
  public personName;
  /** .*/
  public personLast;
  /** .*/
  public email;
  /** .*/
  public cellphone;
  /** .*/
  public emergency;
  /** .*/
  public flagName;
  /** .*/
  public flagLast;
  /** .*/
  public flagNext = null;
  /** .*/
  public flagDisabled;
  /** .*/
  public step4;

  public labelClass: string;
  /** .*/
  public segments: Segment[] = [];

  public fech: NgbDate;
  /**Valida que exista un datos en session, si no existe te regresa al paso de reservaciones */
  ngOnInit() {
    try{
      gtag('config', 'UA-117757515-1', {
        'page_path': '/Express/registro'
    });}catch{}
    console.clear();
    if (!this.session || !this.session.query || !this.session.route || !this.session.segments) {
      this.router.navigate(["/reservaciones"]); return;
    } else {

      var suma = 0;
      this.session.query.passengers.forEach(function (value) {

        suma = suma + value;
      });

      var length = this.session.segments.length;
      this.pixel(this.session.segments[0].selected_travel.date,
        this.session.segments[length - 1].selected_travel.date,
        this.session.segments[length - 1].dst.name,
        this.session.segments[length - 1].dst.name, suma);
       
    }
    this.model.getCountries().subscribe((response: Response<Country[]>) => {
      response.data.forEach(item => {
        this.paises.push(item);
      });
    });

    if (this.session.rb == null) {
      this.session.rb = new RouteBooking();
      this.session.rb.setupFromSession(this.session);
    }

    this.segments = this.session.mkUnifiedSegments();
    this.labelClass = this.session.query.class.toString();

    if (this.session.query.getTotalPassengers() != this.session.rb.persons.length) {

      this.session.rb = new RouteBooking();
      this.session.rb.setupFromSession(this.session);

    }
    console.clear();
  }

  onSubmit(form: NgForm) {

    if (form.invalid) {
      Object.values(form.controls).forEach(control => {
        control.markAsTouched();
      })
      return;
    }
    this.router.navigateByUrl(`/${this.session.route.name}/asientos`)
  }

  getErrorDesc(control: string, error: string) {
    return this.translate.instant(`Step4-${control.toUpperCase()}-${error.toUpperCase()}`);
  }

  hasErrors(): boolean {
    if (this.form.invalid) {
      const error: AllValidationErrors = getFormValidationErrors(this.form.controls).shift();
      if (error) {
        let errorControlName = error.control_name;
        if (error.control_name.includes('person')) {
          const personItem: RegExp = /person\[\d\]/;
          errorControlName = error.control_name.replace(personItem, 'person');
        }
        let text;
        switch (error.error_name) {
          case 'required': text = `${error.control_name} is required!`; break;
          case 'pattern': text = `${error.control_name} has wrong pattern!`; break;
          case 'email': text = `${error.control_name} has wrong email format!`; break;
          case 'minlength': text = `${error.control_name} has wrong length! Required length: ${error.error_value.requiredLength}`; break;
          case 'areEqual': text = `${error.control_name} must be equal!`; break;
          default: text = `${error.control_name}: ${error.error_name}: ${error.error_value}`;
        }
        this.step4 = this.translate.instant(`Step4-${errorControlName.toUpperCase()}-${error.error_name.toUpperCase()}`);
      }
      return true;
    }
    this.step4 = this.translate.instant('Step4-P25');
    return false;
  }

  public haveSeniorCitizen() {

    var totalSenior = this.session.query.passengers[3];

    if (totalSenior > 0) {
      return true;
    } else {
      return false;
    }

  }

  getStartDate(paxType: string) {
    let startDate: NgbDate

    var fecha = new Date();
    switch (paxType) {
      case 'INFANTE':
        startDate = this.ngbCalendar.getPrev(this.TODAY, 'y', 1);
        break;
      case 'MENOR':
        startDate = this.ngbCalendar.getPrev(this.TODAY, 'y', 10);

        break;
      case 'ADULTO':
        startDate = this.ngbCalendar.getPrev(this.TODAY, 'y', 35);

        break;
      case 'ADULTO MAYOR':
        startDate = this.ngbCalendar.getPrev(this.TODAY, 'y', 60);
        break;

    }

    return startDate;

  }

  getMinDate(paxType: string) {
    let minDate: NgbDate
    var DateNow = new Date();

    switch (paxType) {
      case 'INFANTE':
        DateNow.setFullYear(DateNow.getFullYear() - 3);
        break;
      case 'MENOR':
        DateNow.setFullYear(DateNow.getFullYear() - 12);
        break;
      case 'ADULTO':
        //tenia el valor 64
        DateNow.setFullYear(DateNow.getFullYear() - 60);

        break;
      case 'ADULTO MAYOR':
        DateNow.setFullYear(DateNow.getFullYear() - 100);
        break;

    }

    DateNow.setDate(DateNow.getDate() + 1);
    var anio = DateNow.getFullYear();
    var mes = DateNow.getMonth();
    var dia = DateNow.getDate();
    minDate = new NgbDate(anio, mes + 1, dia);
        
    return minDate;
  }

  getMaxDate(paxType: string) {
    let maxDate: NgbDate
    var DateNow = new Date();
    switch (paxType) {
      case 'INFANTE':
        DateNow.setFullYear(DateNow.getFullYear() - 0);
        break;
      case 'MENOR':

        DateNow.setFullYear(DateNow.getFullYear() - 3);
        break;
      case 'ADULTO':

        DateNow.setFullYear(DateNow.getFullYear() - 12);
        break;
      case 'ADULTO MAYOR':

        DateNow.setFullYear(DateNow.getFullYear() - 60);
        break;

    }

    //DateNow.setDate(DateNow.getDate() - 1);
    var anio = DateNow.getFullYear();
    var mes = DateNow.getMonth();
    var dia = DateNow.getDate();
    maxDate = new NgbDate(anio, mes + 1, dia);

    return maxDate;
  }

  /**Función que te permite regresar al paso anterior*/
  goBack(): void {
    this.location.back();
  }
  static email_regex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  static name_regex: RegExp = /^[A-Za-zÑñ\s]{2,30}$/;
  static lastname_regex: RegExp = /^[A-Za-zÑñ\s]{2,30}$/
  static cellphone_regex: RegExp = /^[0-9]{8,16}$/;
  static emergency_regex: RegExp = /^[0-9]{8,16}$/;

  /**Valida que el nombre sea tenga el formato solicitado */
  public pName() {
    if (typeof this.personName != 'undefined') {
      this.personName = this.personName.replace(/^\s+|\s+$/g, "");
      if (!Step4Component.name_regex.test(this.personName)) { this.flagName = true }
      else (this.flagName = null)
    }
  }

  /**Valida que el apellido tenga el formato solicitado */
  public pLast() {
    if (typeof this.personLast != 'undefined') {
      this.personLast = this.personLast.replace(/^\s+|\s+$/g, "");
      if (!Step4Component.lastname_regex.test(this.personLast)) { this.flagLast = true }
      else (this.flagLast = null)
    }
  }

  private pixel(DepartureDate, ReturnDate, DestinationCity,
    DestinationStateorRegion, NumberOfTravelers) {
    /* Please fill the following values. */
    PixelSearch(DepartureDate, ReturnDate, DestinationCity,
      DestinationStateorRegion, "Mexico", NumberOfTravelers);
  }
}
